import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { Cookie, X } from "lucide-react";

const COOKIE_CONSENT_KEY = "cookie-consent";

export function CookieConsent() {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-2 md:p-4 animate-fade-in">
      <div className="container">
        <div className="bg-background/80 backdrop-blur-md border border-border/50 rounded-lg md:rounded-xl shadow-2xl p-3 md:p-5 flex flex-row items-center gap-3 md:gap-6 relative">
          {/* Icon - hidden on mobile */}
          <div className="hidden md:flex w-10 h-10 rounded-full bg-primary/10 items-center justify-center flex-shrink-0">
            <Cookie className="w-5 h-5 text-primary" />
          </div>
          
          {/* Text - compact on mobile */}
          <div className="flex-1 min-w-0">
            <p className="text-xs md:text-sm text-muted-foreground line-clamp-2 md:line-clamp-none">
              <span className="font-medium text-foreground">{t("cookie.title")}:</span>{" "}
              <span className="hidden md:inline">{t("cookie.description")}</span>
              <span className="md:hidden">Сайт использует cookie</span>
            </p>
          </div>
          
          {/* Buttons - compact on mobile */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <Button
              variant="ghost"
              size="sm"
              onClick={handleDecline}
              className="text-xs px-2 md:px-3 h-8"
            >
              {t("cookie.decline")}
            </Button>
            <Button
              size="sm"
              onClick={handleAccept}
              className="text-xs px-3 md:px-4 h-8"
            >
              {t("cookie.accept")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}